import Cookie from 'cookie-universal'

import { ONE_YEAR } from '@mc/constants'

import type { BogoOfferSurfaceName, BogoOfferCountCookie } from './types'

export const COOKIE_OPTIONS = {
  maxAge: ONE_YEAR,
}
export const BOGO_OFFER_ACKNOWLEDGE_COUNT_COOKIE_NAME =
  'bogo_offer_acknowledge_count'
export const BOGO_OFFER_VIEW_COUNT_COOKIE_NAME = 'bogo_offer_view_count'
const defaultBogoOfferCount: BogoOfferCountCookie = {
  offer_modal: 0,
  quiz_interstitial: 0,
  offer_page: 0,
}

const getBogoOfferCountCookie = (cookieName: string): BogoOfferCountCookie =>
  Cookie().get(cookieName) || defaultBogoOfferCount

const incrementBogoOfferCountCookie = (
  cookieName: string,
  surfaceName: BogoOfferSurfaceName,
) => {
  const currentCount = getBogoOfferCountCookie(cookieName)

  Cookie().set(
    cookieName,
    {
      ...currentCount,
      [surfaceName]: currentCount[surfaceName] + 1,
    },
    COOKIE_OPTIONS,
  )
}

export const getBogoOfferAcknowledgeCountCookie = (): BogoOfferCountCookie =>
  getBogoOfferCountCookie(BOGO_OFFER_ACKNOWLEDGE_COUNT_COOKIE_NAME)

export const incrementBogoOfferAcknowledgeCountCookie = (
  surfaceName: BogoOfferSurfaceName,
): void => {
  incrementBogoOfferCountCookie(
    BOGO_OFFER_ACKNOWLEDGE_COUNT_COOKIE_NAME,
    surfaceName,
  )
}

export const getBogoOfferViewCountCookie = (): BogoOfferCountCookie =>
  getBogoOfferCountCookie(BOGO_OFFER_VIEW_COUNT_COOKIE_NAME)

export const incrementBogoOfferViewCountCookie = (
  surfaceName: BogoOfferSurfaceName,
): void => {
  incrementBogoOfferCountCookie(BOGO_OFFER_VIEW_COUNT_COOKIE_NAME, surfaceName)
}
